import jwt_decode from "jwt-decode";
import moment from "moment/moment";

// ✅ Save key in sessionStorage
export const saveKey = ({ key, value }) => {
  try {
    sessionStorage.setItem(key, value);
  } catch (error) {
    console.log("Error in saveToken:", error);
  }
};

// ✅ Save token in sessionStorage
export const saveToken = (token) => {
  try {
    sessionStorage.setItem("token", token);
  } catch (error) {
    console.log("Error in saveToken:", error);
  }
};

// ✅ Get token from sessionStorage
export const getToken = (key = "token") => {
  try {
    const token = sessionStorage.getItem(key);
    console.log("Token:", token);
    return token;
  } catch (error) {
    console.log("Error in getToken:", error);
    return null;
  }
};

// ✅ Decode token payload (from sessionStorage)
export const getTokenPayload = (key = "token") => {
  try {
    const token = getToken(key);
    const payload = token ? jwt_decode(token) : {};
    const storedHasCompanyVerified =
      window.sessionStorage.getItem("hasCompanyVerified");
    const tokenCompanyVerified = payload?.hasCompanyVerified;

    let normalizedHasCompanyVerified = null;
    if (storedHasCompanyVerified === "true") {
      console.log("hasCompanyVerified s1", storedHasCompanyVerified);
      normalizedHasCompanyVerified = true;
    } else if (storedHasCompanyVerified === "false") {
      console.log("hasCompanyVerified s2", storedHasCompanyVerified);
      normalizedHasCompanyVerified = false;
    }

    if (typeof tokenCompanyVerified === "boolean") {
      normalizedHasCompanyVerified = tokenCompanyVerified;
    } else if (tokenCompanyVerified === "true") {
      normalizedHasCompanyVerified = true;
    } else if (tokenCompanyVerified === "false") {
      normalizedHasCompanyVerified = false;
    }

    console.log("Payload:", payload, normalizedHasCompanyVerified);

    return {
      ...payload,
      isNewUser: payload?.isNewUser ?? false,
      hasCompanyProfile: payload?.hasCompanyProfile ?? false,
      hasCompanyVerified: normalizedHasCompanyVerified,
    };
  } catch (error) {
    console.log("Error in getTokenPayload:", error);
    return {};
  }
};

// ✅ Remove token from sessionStorage
export const removeToken = (key = "token") => {
  try {
    sessionStorage.removeItem(key);
    console.log("Token removed");
  } catch (error) {
    console.log("Error in removeToken:", error);
  }
};

export const checkTokenExpiry = () => {
  try {
    const token = sessionStorage.getItem("token");
    const payload = getTokenPayload("token");
    const { exp } = payload;

    if (!token || !exp) {
      return true;
    }

    const expiryTime = moment.unix(exp);
    const now = moment();

    if (now.isAfter(expiryTime)) {
      console.log("Token is expired please login");
      removeToken();
      return true;
    } else {
      return false;
    }

    // return token;
  } catch (err) {
    throw err;
  }
};
